export default {
  markets: {
    id: 'bo_seller-options-shipping-rule_drawer-markets',
    defaultMessage: 'Market(s)',
  },
  states: {
    id: 'bo_seller-options-shipping-method_list-states',
    defaultMessage: 'States',
  },
  cannotDeleteFreeMethod: {
    id: 'bo_seller-options-shipping-rule_drawer-cannot_delete_free_method',
    defaultMessage:
      'To delete this free shipping option, delete the paid shipping option first.',
  },
} as const
